import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';
import { formatCurrency } from '../../utils/formatters';

const TopProductsChart = ({ data = [], loading = false }) => {
  if (loading) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
        <div className="h-4 w-32 bg-theme-tertiary rounded mb-4 animate-pulse"></div>
        <div className="h-64 bg-theme-tertiary rounded animate-pulse"></div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
                <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Top Selling Products</h3>
        <div className="h-64 flex items-center justify-center text-theme-muted">
          <p>No product data available</p>
        </div>
      </div>
    );
  }

  const formattedData = data.map(item => ({
    name: item.product_code || item.product_name || 'Unknown',
    sold: parseInt(item.total_sold || 0),
    revenue: parseFloat(item.total_revenue || 0)
  })).slice(0, 10);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-theme-secondary p-3 border border-theme rounded-lg shadow-theme-lg">
          <p className="text-sm font-medium text-theme-muted mb-1">{payload[0].payload.name}</p>
          <p className="text-sm font-semibold text-accent-gold">
            Units Sold: {payload[0].value}
          </p>
          <p className="text-sm text-theme-secondary">
            Revenue: {formatCurrency(payload[0].payload.revenue)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-theme-secondary rounded-lg shadow-theme-md p-4 md:p-6 border border-theme">
              <h3 className="text-base md:text-lg font-semibold text-theme-primary mb-4">Top Selling Products</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={formattedData} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis type="number" tick={{ fill: 'var(--color-text-muted)', fontSize: 12 }} />
          <YAxis
            dataKey="name"
            type="category"
            width={80}
            tick={{ fill: 'var(--color-text-muted)', fontSize: 11 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: '14px', color: 'var(--color-text-primary)' }} />
          <Bar dataKey="sold" fill="#D4AF37" name="Units Sold" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopProductsChart;
